import apiClient from 'services/axios'
import ApiConfig from 'services/config'
import errorHandler from 'components/error.handler'

const { CustomerConfig } = ApiConfig

export default async function unlinkCard({ code, customerId, cardId }) {
  return apiClient
    .get(
      `${CustomerConfig.UNLINK_CARDS.replace(':id', customerId).replace(':cardId', cardId)}${code}`,
    )
    .then(response => {
      return response?.data?.customer ?? {}
    })
    .catch(({ data }) => {
      errorHandler(data)
    })
}

export function getCustomerTags() {
  return apiClient.get(`${CustomerConfig.CUSTOMER_TAGS}`).then(response => response?.data)
}

export function getCustomerAudience(filters) {
  return apiClient
    .post(CustomerConfig.CUSTOMER_AUDIENCE, { filters })
    .then(response => response?.data)
}
